import axios from 'axios'

class PersonalMessage {
  constructor() {
    this.baseUrl = '/api/v1'
  }

  saveMood(data) {
    return axios.post(`${this.baseUrl}/mood-capture/`, data)
  }

  saveInsomnia() {
    return axios.put(`${this.baseUrl}/healthdashboard/update_insomnia_status/`)
  }
}

export const personalMoodCapture = new PersonalMessage()
